// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"342":"7a6ec5c5","496":"0f88f3af","511":"2be92ea4","789":"82007b54","841":"7437ce03","908":"60fa6cd4","912":"74940d64","955":"0acdf32c"}[chunkId] + ".js";
};